export default __webpack_public_path__ + "static/media/qna.d7d5ef43.gif";